export default {"src":"/_next/static/media/0xb39eeb9e168ef6c639f5e282fef1f6bc4dcae375.c015a2ac.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};